import * as React from "react";
const BigInfoCircle = (props: any) => (
  <svg
    width={100}
    height={100}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.9997 94.7904C25.2913 94.7904 5.20801 74.707 5.20801 49.9987C5.20801 25.2904 25.2913 5.20703 49.9997 5.20703C74.708 5.20703 94.7914 25.2904 94.7914 49.9987C94.7914 74.707 74.708 94.7904 49.9997 94.7904ZM49.9997 11.457C28.7497 11.457 11.458 28.7487 11.458 49.9987C11.458 71.2487 28.7497 88.5404 49.9997 88.5404C71.2497 88.5404 88.5414 71.2487 88.5414 49.9987C88.5414 28.7487 71.2497 11.457 49.9997 11.457Z"
      fill="#292D32"
    />
    <path
      d="M50 57.2904C48.2917 57.2904 46.875 55.8737 46.875 54.1654V33.332C46.875 31.6237 48.2917 30.207 50 30.207C51.7083 30.207 53.125 31.6237 53.125 33.332V54.1654C53.125 55.8737 51.7083 57.2904 50 57.2904Z"
      fill="#292D32"
    />
    <path
      d="M49.9997 70.832C49.458 70.832 48.9163 70.707 48.4163 70.4987C47.9163 70.2904 47.458 69.9987 47.0413 69.6237C46.6663 69.207 46.3747 68.7904 46.1663 68.2487C45.958 67.7487 45.833 67.207 45.833 66.6654C45.833 66.1237 45.958 65.582 46.1663 65.082C46.3747 64.582 46.6663 64.1237 47.0413 63.707C47.458 63.332 47.9163 63.0404 48.4163 62.832C49.4163 62.4154 50.583 62.4154 51.583 62.832C52.083 63.0404 52.5413 63.332 52.958 63.707C53.333 64.1237 53.6247 64.582 53.833 65.082C54.0413 65.582 54.1663 66.1237 54.1663 66.6654C54.1663 67.207 54.0413 67.7487 53.833 68.2487C53.6247 68.7904 53.333 69.207 52.958 69.6237C52.5413 69.9987 52.083 70.2904 51.583 70.4987C51.083 70.707 50.5413 70.832 49.9997 70.832Z"
      fill="#292D32"
    />
  </svg>
);
export default BigInfoCircle;
